export default {
  title_developers: 'All Developers',
  breadcrumbs: {
    home: 'Home',
    developers: 'Developers'
  },
  logo_alt: 'Developer logo',
  banner_alt: 'Developer banner',
  gallery_image_alt: 'Gallery image',
  founded: 'Founded',
  residential_complexes: 'Residential Complexes',
  buildings: 'Buildings',
  properties: 'Properties',
  no_available: 'No available developers',
  gallery: 'Gallery',
  video: 'Video',
  contacts: 'Contacts',
  residential_complexes_from: 'Residential complexes by {name}',
  properties_from: 'Properties by {name}',
  tabs: {
    base: 'General',
    media: 'Media'
  },
  fields: {
    name: 'Name',
    founded_year: 'Year founded',
    website: 'Website',
    email: 'Email',
    phone: 'Phone',
    country: 'Country',
    description_html: 'Description (HTML)',
    project_types: 'Project types',
    locations: 'Locations'
  },
  buttons: {
    more: 'More details',
    pagination: {
      prev: 'Previous',
      next: 'Next'
    }
  }
}
